
define(function (require) {
    "use strict";

    var _ = require("underscore");
    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var Validator = require("user-management-utils/Validator");

    var SkillLoadBalanceSectionModel = {};

    var KEYS = {
        AGENT_GROUP_ID:'agentGroupId',
        SPLIT_PERCENTAGE: 'splitPercentage'
    };

    LE.module('LEUserManagement', function (LEUserManagement, LE, Backbone, Marionette, $, _) {

        SkillLoadBalanceSectionModel = BaseModel.extend({
            KEYS: KEYS,
            defaults:{
                priority: 1,
                agentGroupId: "",
                splitPercentage: ""
            },

            saveEnableValidation: {
                agentGroupId: {
                    fn: function(val) {
                        if ("" === val && !this.getAgentGroupId()) {
                            return "LEUserManagement.skillEdit.errors.load.balancing.percentage.100";
                        }
                    }
                },
                splitPercentage: [
                    {
                        required: true,
                        minLength: 1,
                        msg: "LEUserManagement.skillEdit.errors.load.balancing.percentage.100"
                    }
                ]
            },
            name: "SkillLoadBalanceSectionModel",

            setPriority: function(priority) {
                this.set("priority", priority);
            },

            getPriority: function() {
                return this.get("priority");
            },

            setLoadBalanceId: function(loadBalanceId) {
                this.set("loadBalanceId", loadBalanceId);
            },

            getLoadBalanceId: function() {
                return this.get("loadBalanceId");
            },

            setAgentGroupId: function(agentGroupId) {
                this.set("agentGroupId", agentGroupId);
            },

            getAgentGroupId: function() {
                return this.get("agentGroupId");
            },

            setSplitPercentage: function(splitPercentage) {
                this.set("splitPercentage", splitPercentage);
            },

            getSplitPercentage: function() {
                return this.get("splitPercentage");
            },

            validateSaveEnabled: function () {
                this.originalValidation = this.validation;
                this.validation = this.saveEnableValidation;

                var enable = this.isValid();

                this.validation = this.originalValidation;

                return enable;
            }
        });
    });

    SkillLoadBalanceSectionModel.KEYS = KEYS;
    return SkillLoadBalanceSectionModel;
});
